// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1o09>div{min-height:3rem}._2Mnz{margin-left:1rem}._2XKE{min-height:2.5rem}._2i5L{margin-bottom:.5rem}html[dir=rtl] ._2Mnz{margin-left:0;margin-right:1rem}", ""]);
// Exports
exports.locals = {
	"input": "_1o09",
	"indicator": "_2Mnz",
	"messages": "_2XKE",
	"checkbox": "_2i5L"
};
module.exports = exports;
